import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Side effect: applies the stored light/dark/auto preference to <html> and
// starts tracking the OS setting.
import './hooks/useTheme';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
